var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppIconScreeningEagleInspect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1240 1240",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M212 0h816c117.1 0 212 94.9 212 212v816c0 117.1-94.9 212-212 212H212c-117.1 0-212-94.9-212-212V212C0 94.9 94.9 0 212 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#009CA6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M858.2 444.4s9-117.5-191.4-121.3c-140.3-2.7-336 99.5-355.4 341 0 .1-.4 15.7-.4 20.6 0 166.1 96.2 197.9 96.2 197.9s-33.7-54.3-9.6-112.3c0 0-16.7 147.5 147.4 147.4 0 0-43.1-29.3-47.6-75.9 0 0 106.3 116.7 241.3 21.8 0 0-208.5 6.7-251.8-155.6 0 0 110.3 149.1 297.9 118.5 0 0-87.9-34.1-82.6-133.6 5.2-99.5 108.2-121.8 108.2-121.8s-40.7-54.8-121.6-54.8c-3-.1-6.1-.1-9.2-.1 8.7-.5 17.7-2.3 26.5-2.3 0 0 188.2-20.7 167.8 49 0 0 39.4-3 51.5-29.5 12.1-26.8-18.6-68.5-67.2-89zm-158.9-8.8c-14.6-2.7-23.9-24.4-32.7-39.9-9.7-17-.5-22.6 35.5-15.4 36.1 7.2 94.7 65.9 94.7 65.9s-87.7-8.9-97.5-10.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppIconScreeningEagleInspect);
export default new URL("/builds/software-solutions/workspace/web/eagleid-fe-workspace/src/images/appIconScreeningEagleInspect.svg", import.meta.url).toString();
export { ForwardRef as ReactComponent };